<template>
    <div class="container">
        <div class="title-container" @click="change">
            <div class="title m-title">{{data.title}}</div>
            <div class="counter sum">{{sum}}</div>
        </div>
        <template v-for="item in [
        {'name':'Booking','num':data.booking},
        {'name':'FeedBack','num':data.feedBack},
        {'name':'Checklist','num':data.checklist},
        {'name':'Form','num':data.form},]">
            <div :key="item.name" class="item-container" v-if="showItems">

                <div class="item-title title">{{item.name}}</div>
                <div class="counter item-num"> {{item.num}}</div>
            </div>
        </template>
    </div>

</template>

<script>
    export default {
        name: 'DashBoardItem',
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        data: function () {
            return {
                showItems: true,
                sum: this.data.booking + this.data.checklist + this.data.feedBack + this.data.form
            }
        },
        methods: {
            change() {
                this.showItems = !this.showItems
            }
        }
    }
</script>

<style scoped>

    .container {
        width: 300px;
    }

    .item-container {
        height: 50px;
        border-left: #3278B4 1px solid;
        border-right: #3278B4 1px solid;
        border-bottom: #3278B4 1px solid;
        cursor: pointer;
    }

    .title-container {
        height: 60px;
        background: #3278B4;
        border-radius: 5px 5px 0 0;
        text-align: center;
        cursor: pointer;
    }


    .title {
        margin-left: 20px;
        float: left;
    }
    .m-title {
        font-size: xx-large;
        color: white;
        line-height: 60px;
    }
    .item-title{
        line-height: 50px;
        font-size: large;
    }

    .counter {
        font-size: large;
        width: 26px;
        height: 26px;
        background: #999999;
        border-radius: 100%;
        text-align: center;
        color: white;
        float: right;
        margin-right: 20px;
    }
    .sum{
        margin-top: 16px;
    }
    .item-num{
        margin-top: 12px;
    }
</style>
